import TextArea from "@visa/vds/textarea";
import React from "react";
import { useController } from "react-hook-form";
import { FormHelper } from "../_helpers/FormHelper";

function MCSControlTextArea(props) {
  const { field, fieldState } = useController(props);
  const handleChange = (e) => {
    field.onChange(e.target.value.trimLeft());
    props.handleChange();
  };
  return (
    <TextArea
      value={field.value}
      onChange={handleChange}
      label={props.label}
      maxLength={props.maxLength}
      invalid={fieldState.invalid}
      showErrorText={fieldState.invalid}
      errorText={FormHelper.renderErrorMsg(fieldState.error)}
      showCounter={props.showCounter}
      maxCharacters={props.maxCharacters}
      readOnly={props.readOnly}
    />
  );
}

export default MCSControlTextArea;
